import { Component, Input } from '@angular/core';
import { Entity, OrderRowModel } from 'hx-services';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'hx-order-icon',
    templateUrl: './order-icon.component.html',
    styleUrls: ['./order-icon.component.css'],
    imports: [NgIf, NgClass]
})
export class HxOrderIconComponent {
  @Input()
  set order(val: OrderRowModel) {
    this.model = val;
    this.isDelivery = !!val.deliveryRangeTime;
    this.isLegal =  val.clientType === Entity.LEGAL;
  }

  model!: OrderRowModel;
  isDelivery = false;
  isLegal = false;
}
